<template>
  <div class="Register">
    <div class="d-flex align-items-center glavni">
      <div class="container text-center">
        <img src="../assets/img/demo.svg" alt="demo" class="m-5">
        <form class="form-signin" @submit.prevent="signup">
          <div class="row justify-content-center">
            <div class="col-6 col-width">
              <input
                v-model="name"
                id="inputName"
                class="form-control my-2 text-center radijus"
                type="text"
                placeholder="Name"
              >
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 col-width"> 
              <input
                v-model="email"
                type="email" name="email" id="inputEmail"
                class="form-control my-2 text-center radijus"
                placeholder="E-mail"
              >
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 col-width">
              <input
                v-model="password"
                input type="password" name="password" id="inputPassword"
                class="form-control my-2 text-center radijus"
                placeholder="Password"
              >
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 col-width">
              <input
                v-model="password_confirmation"
                id="repeatPassword"
                class="form-control my-2 text-center radijus"
                type="text"
                placeholder="Repeat Password"
              >
            </div>
          </div>
          <div class="row justify-content-center">
            <button
              type="submit"
              class="col-2 my-4 text-center radijus mint-bcg text-white p-2"
            >SUBMIT</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Register",
  data() {
    return {
      name: "",
      email: "",
      password: "",
      password_confirmation: ""
    };
  },
  methods: {
    signup() {
      axios.post("https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/auth/signup",
          {
            name: this.name,
            email: this.email,
            password: this.password,
            password_confirmation: this.password_confirmation
          }
        )
        .then(request => this.signupSuccessful(request))
        .catch(() => this.signupFailed());
    },
    signupSuccessful() {
      this.$swal({
        position: 'center',
        type: 'success',
        title: `Registration successfull`,
        showConfirmButton: false,
        timer: 3000
      });
      this.$router.replace(this.$route.query.redirect || "/RegistrationSuccess");
    },
      signupFailed() {
      this.error = "Sign Up failed!";

      //  delete localStorage.token
    }
  }
};
</script>

<style scoped>
@import "../style.css";

.glavni {
  height: 100vh;
  background-image: url("../assets/img/group-5796.png");
  background-repeat: no-repeat;
}
::placeholder {
  color: #29e4b7!Important;
  font-weight: bold;
}
.radijus {
  border-radius: 25px;
}

.mint-bcg {
  background-color: #29e4b7;
}
</style>